import { PropertyLocationDto } from '@tallo/property';

type BuildingAddress = Pick<PropertyLocationDto, 'address' | 'city' | 'state' | 'zip'>;

/** "500 Sheridan Rd, Chicago, IL": the line under a building's name (`getFormattedAddress` adds the zip) */
export function buildingAddressLine({ address, city, state }: Pick<BuildingAddress, 'address' | 'city' | 'state'>) {
  return [address, city, state].filter(Boolean).join(', ');
}

/** "Chicago, IL 60640": the line under the street on a location card */
export function buildingCityLine({ city, state, zip }: Pick<BuildingAddress, 'city' | 'state' | 'zip'>) {
  return [city, [state, zip].filter(Boolean).join(' ')].filter(Boolean).join(', ');
}

/** A search for the address, which works without coordinates and lands on the right place */
export function buildingMapsUrl({ address, city, state, zip }: BuildingAddress) {
  const query = [address, city, state, zip].filter(Boolean).join(', ');

  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}
